import React from 'react';

const STEP_LABELS = ['Founder Info', 'Business Details', 'Investment Ask', 'Review & Submit'];

export default function StepIndicator({ currentStep, totalSteps }) {
  return (
    <div className="flex items-center justify-center gap-0 mb-2">
      {Array.from({ length: totalSteps }, (_, i) => {
        const step = i + 1;
        const isCompleted = step < currentStep;
        const isActive = step === currentStep;
        return (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center">
              <div
                className="w-9 h-9 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 border-2"
                style={{
                  background: isCompleted ? '#D4A520' : isActive ? '#0B1F3B' : '#fff',
                  borderColor: isCompleted || isActive ? '#D4A520' : '#D1D5DB',
                  color: isCompleted ? '#0B1F3B' : isActive ? '#D4A520' : '#9CA3AF',
                }}
              >
                {isCompleted ? (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M3 8l3.5 3.5L13 5" stroke="#0B1F3B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : step}
              </div>
              <span
                className="text-xs mt-1.5 font-medium hidden sm:block"
                style={{ color: isActive ? '#0B1F3B' : isCompleted ? '#D4A520' : '#9CA3AF' }}
              >
                {STEP_LABELS?.[i]}
              </span>
            </div>
            {step < totalSteps && (
              <div
                className="flex-1 h-0.5 mx-1 transition-all duration-300"
                style={{ background: step < currentStep ? '#D4A520' : '#E5E7EB', minWidth: 24, maxWidth: 80 }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
